export const USER_ROLES = {
  USER: 'ROLE_USER',
  ADMIN: 'ROLE_ADMIN',
  SYSTEM_ADMIN: 'ROLE_SYSTEM_ADMIN',
  SYSTEM_SUPPORT: 'ROLE_SYSTEM_SUPPORT',
};
